import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

import {PageItem} from '@models/sidebar/page-item';

@Injectable({
  providedIn: 'root'
})
export class UpdateUrlService {

  private behaviourSubject = new BehaviorSubject(new PageItem());
  updateUrlMenuNotification = this.behaviourSubject.asObservable();

  broadcast(pageItem: PageItem) {
    this.behaviourSubject.next(pageItem);
  }

}
